import { apiWithkey } from "../axios";
import { baseApiURL, selectedPlan } from "../endpoints";
import useUserStore from "../../storeModules/useUserStore";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";

const sendSelectedPlan = async () => {
  const url = new URL(`${baseApiURL}${selectedPlan}`);

  const userLeadID = useUserStore.getState().lead.LeadID;
  const empresaID = useInitialConfigStore.getState().empresaId;
  const { planoID, bemID } = useConsorcioStore.getState().selectedPlano;

  const sendSelectedPlanProps = {
    leadID: userLeadID,
    empresaID: empresaID,
    planoID: planoID,
    bemID: bemID,
  };

  return apiWithkey.post(url, sendSelectedPlanProps);
};

export { sendSelectedPlan };
